import React from "react";
import { Form, FloatingLabel } from "react-bootstrap";

interface NewsMediaFormProps {
  year: string;
  artist: string;
  category: string;
  title: string;
  media: string;
  datePosted: string;
  link: string;
  thumbnail?: File | string | null;
  thumbnail_name?: string; 
  onYearChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onArtistChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCategoryChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onTitleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onMediaChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDatePostedChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onLinkChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onThumbnailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function NewsMediaForm({
  year,
  artist,
  category,
  title,
  media,
  datePosted,
  link,
  thumbnail,
  thumbnail_name,
  onYearChange,
  onArtistChange,
  onCategoryChange,
  onTitleChange,
  onMediaChange,
  onDatePostedChange,
  onLinkChange,
  onThumbnailChange,
}: NewsMediaFormProps) {
  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="formYear">
            <label className="text-sm mb-2">Year</label>
            <FloatingLabel controlId="floatingInput" label="Year" className="mb-3">
              <Form.Control
                type="text"
                placeholder="Year"
                value={year}
                onChange={onYearChange}
                className='bg-gray-200'
              />
            </FloatingLabel>
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="formArtist">
            <label className="text-sm mb-2">Artist</label>
            <FloatingLabel
              controlId="floatingInput"
              label="Artist"
              className="mb-3"
            >
              <Form.Control
                type="text"
                placeholder="Artist"
                value={artist}
                onChange={onArtistChange}
                className='bg-gray-200'
              />
            </FloatingLabel>
          </Form.Group>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="formCategory">
            <label className="text-sm mb-2">Category</label>
            <Form.Select
              aria-label="Select Category"
              value={category}
              className="bg-gray-200 py-3"
              onChange={onCategoryChange} 
            >
              <option value="">Select Category</option>
              <option value="Article">Article</option>
              <option value="Photo">Photo</option>
              <option value="Video">Video</option>
            </Form.Select>
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="formTitle">
            <label className="text-sm mb-2">Title</label>
            <FloatingLabel controlId="floatingInput" label="Title" className="mb-3">
              <Form.Control
                type="text"
                placeholder="Title"
                value={title}
                onChange={onTitleChange}
                className='bg-gray-200'
              />
            </FloatingLabel>
          </Form.Group>
        </div>
      </div>
        
      <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="formMedia">
            <label className="text-sm mb-2">Media</label>
            <FloatingLabel controlId="floatingInput" label="Media" className="mb-3">
              <Form.Control
                type="text"
                placeholder="Media"
                value={media}
                onChange={onMediaChange}
                className='bg-gray-200'
              />
            </FloatingLabel>
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="formDatePosted">
            <label className="text-sm mb-2">Date Posted</label>
            <FloatingLabel
              controlId="floatingInput"
              label="Date Posted"
              className="mb-3"
            >
              <Form.Control
                type="date"
                placeholder="Date Posted"
                value={datePosted}
                onChange={onDatePostedChange}
                className='bg-gray-200'
              />
            </FloatingLabel>
          </Form.Group>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="formLink">
            <label className="text-sm mb-2">Link</label>
            <FloatingLabel controlId="floatingInput" label="Link" className="mb-3">
              <Form.Control
                type="text"
                placeholder="Link"
                value={link}
                onChange={onLinkChange}
                className='bg-gray-200'
              />
            </FloatingLabel>
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="formThumbnail">
            <Form.Label className="text-sm mb-2">Thumbnail Image (Max Size: 2mb)</Form.Label>
            <Form.Control type="file" className='bg-gray-200 mb-2' onChange={onThumbnailChange} />
            {(thumbnail) && (
              <>
                <Form.Text className="text-xsm text-muted d-block">Thumbnail Image</Form.Text>
                <Form.Text className="text-black d-block pb-3 hover:text-red-500">
                  {thumbnail ? (
                    typeof thumbnail === "string" ? (
                      <a href={`https://cdn.pulp.ph/storage/${thumbnail}`} target="_blank" rel="noopener noreferrer">
                        {thumbnail}
                      </a>
                    ) : (
                      "Thumbnail is a file, can't display as link"
                    )
                  ) : (
                    "No Uploaded files on server"
                  )}
                </Form.Text>
              </>
            )}
          </Form.Group>
        </div>
      </div>
    </>
  );
}
